import React from 'react'
import HiringPage from '../Pages/HomePage/HiringPage'

function Hiringpage() {
  return (
    <>
        <HiringPage />
    </>
  )
}

export default Hiringpage
